import styled from "styled-components";
import { useModal } from "../../../contexts/ModalContext"
import ModalAddValorNF from "./ModalAddValorNF";
import { formatBRLFromCents } from "../../../Funcoes/Money";

import { GoTrash, GoPencil, GoSearch } from "react-icons/go";

const Container = styled.div`
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    box-sizing: border-box;
    margin-top: 15px;
    overflow: hidden;
`
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    color: #333;
    & thead {
        background-color: #f0f0f0;
    }
    & thead tr {
        height: 40px;
        text-align: left;
    }
    & thead th {
        padding: 0 15px;
        font-size: 12px;
        font-weight: bold;
    }
    & tbody tr {
        height: 40px;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
    & tbody td {
        padding: 0 15px;
        font-size: 12px;
    }
`
const BotaoAdicionar = styled.button`
    margin: 10px 0 0 auto;
    padding: 9px 12px;
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
        background-color: #1e40af;
    }
`
const ColunaAcoes = styled.td`
    width: 65px;
`
const IconesWrapper = styled.div`
    width: 65px;
    display: flex;
    gap: 10px;
    height: 20px;
`
const Lixeira = styled(GoTrash)`
    height: 20px;
    width: 20px;
    color: #e11d48;
    cursor: pointer;
    transition: .2s all ease;
    &:hover {
        color: #be123c;
    }
`
const Lapis = styled(GoPencil)`
    height: 20px;
    width: 20px;
    color: #2563eb;
    cursor: pointer;
    transition: .2s all ease;
    &:hover {
        color: #1e40af;
    }
`


const TableNFs = ({ listaNF, setListaNF }) => {

    const { openModal } = useModal();

    const RemoverNF = (id) => {
        setListaNF((prev) => prev.filter((nf) => nf.id !== id));
    }

    return (
        <>
            <Container>
                <Tabela>
                    <thead>
                        <tr>
                            <th>NÚMERO NF</th>
                            <th>VALOR NF</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaNF?.length === 0 ? (
                                <tr>
                                    <td colSpan={3} style={{ textAlign: "center" }}>
                                        NENHUMA NF ADICIONADA
                                    </td>
                                </tr>
                            ) :
                                listaNF.map((nf) => (
                                    <tr key={nf.id} >
                                        <td>{nf.numNF}</td>
                                        <td>{formatBRLFromCents(nf.valorNF)}</td>
                                        <ColunaAcoes>
                                            <IconesWrapper>
                                                <Lapis />
                                                <Lixeira onClick={() => RemoverNF(nf.id)} />
                                            </IconesWrapper>
                                        </ColunaAcoes>
                                    </tr>
                                ))
                        }
                    </tbody>
                </Tabela>
            </Container>
            <BotaoAdicionar
                type="button"
                onClick={() => openModal('addValorNF')}
            >
                ADICIONAR NF
            </BotaoAdicionar>
        </>
    )

}

export default TableNFs;